<template>
  <div class="justify-content-center text-left dp02 p-3">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>
    </div>
    <div
      class="row col-lg-12 mt-5">
      <div class="col-12">
        <h2>{{ $t('CreateCustomer.header') }}</h2>
      </div>
      <ValidationObserver ref="observer"
                          class="row col-12"
                          v-slot="{invalid}"
                          tag="form"
                          @submit.prevent="submit()">
        <div class="col-4">
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.street') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="street"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="street" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.streetNumber') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="streetNumber"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="streetNumber" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.city') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="city"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="city" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.zipCode') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="zipCode"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="zipCode" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.name') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="name" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.surname') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="surname"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="surname" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.email') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="email"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="email" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.gender') }}:</label>
            </div>
            <div class="col-lg-9">
              <GenderInput
                v-model="gender"
                :with-both="false" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="gender">{{ $t('fields.agreedToDataProcessing') }}:</label>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox
                v-model="agreedToDataProcessing"
                :value="true"
                :unchecked-value="false" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="gender">{{ $t('fields.agreedToTermsOfService') }}:</label>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox
                v-model="agreedToTermsOfService"
                :value="true"
                :unchecked-value="false" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.phone') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="phone"
                ref="phoneInput"
                rules="required"
                v-slot="{errors, classes}">
                <PhoneNumberInput
                  :editable="true"
                  v-model="phone" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('common.Password') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="password"
                rules="required|password:confirmPassword"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  type="password"
                  v-model="password" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('common.ConfirmPassword') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="confirmPassword"
                ref="confirmPassword"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  type="password"
                  v-model="confirmPassword" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="gender">{{ $t('entities.ProductType.Singular') }}:</label>
            </div>
            <div class="col-lg-4">
              <ProductTypeInput v-model="productTypeId" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="gender">{{ $t('common.PaidInCash') }}:</label>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox
                v-model="paidInCash"
                :value="true"
                :unchecked-value="false" />
            </div>
          </div>
        </div>
        <div class="row col-4 offset-7">
          <b-button
            type="submit"
            class="myButton align-middle">
            {{ $t("common.Create") }}
          </b-button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import GenderInput from '@components/input/GenderInput';
import ProductTypeInput from '@components/input/ProductTypeInput';
import PhoneNumberInput from '@components/input/PhoneNumberInput';

export default {
  name: 'CustomerCreate',
  components: {
    GenderInput, ProductTypeInput, PhoneNumberInput
  },
  data() {
    return {
      confirmPassword: ''
    };
  },
  computed: {
    email: {
      get() {
        return this.$store.state.createCustomer.email;
      },
      set(val) {
        this.setEmail(val);
      }
    },
    agreedToTermsOfService: {
      get() {
        return this.$store.state.createCustomer.agreedToTermsOfService;
      },
      set(val) {
        this.setAgreedToTermsOfService(val);
      }
    },
    agreedToDataProcessing: {
      get() {
        return this.$store.state.createCustomer.agreedToDataProcessing;
      },
      set(val) {
        this.setAgreedToDataProcessing(val);
      }
    },
    name: {
      get() {
        return this.$store.state.createCustomer.name;
      },
      set(val) {
        this.setName(val);
      }
    },
    surname: {
      get() {
        return this.$store.state.createCustomer.surname;
      },
      set(val) {
        this.setSurname(val);
      }
    },
    phone: {
      get() {
        return this.$store.state.createCustomer.phone;
      },
      set(val) {
        this.setPhone(val);
      }
    },
    gender: {
      get() {
        return this.$store.state.createCustomer.gender;
      },
      set(val) {
        this.setGender(val);
      }
    },
    street: {
      get() {
        return this.$store.state.createCustomer.street;
      },
      set(val) {
        this.setStreet(val);
      }
    },
    streetNumber: {
      get() {
        return this.$store.state.createCustomer.streetNumber;
      },
      set(val) {
        this.setStreetNumber(val);
      }
    },
    city: {
      get() {
        return this.$store.state.createCustomer.city;
      },
      set(val) {
        this.setCity(val);
      }
    },
    zipCode: {
      get() {
        return this.$store.state.createCustomer.zipCode;
      },
      set(val) {
        this.setZipCode(val);
      }
    },
    password: {
      get() {
        return this.$store.state.createCustomer.password;
      },
      set(val) {
        this.setPassword(val);
      }
    },
    productTypeId: {
      get() {
        return this.$store.state.createCustomer.productTypeId;
      },
      set(val) {
        this.setProductTypeId(val);
      }
    },
    paidInCash: {
      get() {
        return this.$store.state.createCustomer.paidInCash;
      },
      set(val) {
        this.setPaidInCash(val);
      }
    }
  },
  methods: {
    ...mapActions({
      resetContext: 'createCustomer/resetContext',
      createCustomer: 'createCustomer/createCustomer'
    }),
    ...mapMutations({ setName: 'createCustomer/setName',
      setSurname: 'createCustomer/setSurname',
      setPhone: 'createCustomer/setPhone',
      setGender: 'createCustomer/setGender',
      setStreet: 'createCustomer/setStreet',
      setStreetNumber: 'createCustomer/setStreetNumber',
      setCity: 'createCustomer/setCity',
      setZipCode: 'createCustomer/setZipCode',
      setPassword: 'createCustomer/setPassword',
      setAgreedToDataProcessing: 'createCustomer/setAgreedToDataProcessing',
      setAgreedToTermsOfService: 'createCustomer/setAgreedToTermsOfService',
      setEmail: 'createCustomer/setEmail',
      setProductTypeId: 'createCustomer/setProductTypeId',
      setPaidInCash: 'createCustomer/setPaidInCash' }),
    async submit() {
      let isValid = Boolean(this.phone.prefix);
      if (!isValid) {
        this.$refs.phoneInput.setErrors(['Zadejte platné telefonní číslo']);
        return;
      }
      // eslint-disable-next-line no-restricted-globals
      isValid = this.phone.number.length > 0 && !isNaN(this.phone.number);
      if (!isValid) {
        this.$refs.phoneInput.setErrors(['Zadejte platné telefonní číslo']);
        return;
      }
      isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.createCustomer()
          .then(() => {
            this.resetContext();
            this.$root.$bvToast.toast(this.$t('CreateCustomer.SuccessToast.Body'), {
              title: this.$t('CreateCustomer.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$router.replace({ name: 'admin.customers.view' });
          })
          .catch(() => {
            this.$root.$bvToast.toast(this.$t('CreateCustomer.FailToast.Body'), {
              title: this.$t('CreateCustomer.FailToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
      }
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
